import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../config';
import './DataPage.css';

const styles = {
  pageHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '24px',
    flexWrap: 'wrap',
    gap: '12px',
  },
  pageIcon: {
    fontSize: '1.5rem',
    lineHeight: 1,
  },
  pageTitle: {
    fontSize: '1.5rem',
    fontWeight: '700',
    color: '#1a1a2e',
    margin: '0 0 2px 0',
  },
  pageSubtitle: {
    fontSize: '0.85rem',
    color: '#666',
    margin: 0,
  },
  loadingIndicator: {
    marginLeft: '8px',
    color: '#1976d2',
  },
  countersRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
    gap: '16px',
    marginBottom: '24px',
  },
  counterCard: (color) => ({
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '20px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    borderLeft: `4px solid ${color}`,
  }),
  counterLabel: {
    fontSize: '0.8rem',
    color: '#666',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: '4px',
  },
  counterValue: {
    fontSize: '1.75rem',
    fontWeight: '700',
    color: '#333',
  },
  filtersCard: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '20px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    marginBottom: '24px',
    display: 'flex',
    gap: '16px',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
  },
  filterGroup: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 250px',
  },
  filterLabel: {
    fontSize: '0.8rem',
    color: '#666',
    fontWeight: '600',
    marginBottom: '6px',
  },
  searchInput: {
    padding: '10px 14px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    fontSize: '0.9rem',
    color: '#333',
    outline: 'none',
    width: '100%',
    boxSizing: 'border-box',
  },
  filterSelect: {
    padding: '10px 14px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    fontSize: '0.9rem',
    color: '#333',
    outline: 'none',
    backgroundColor: '#fff',
    cursor: 'pointer',
    width: '100%',
    boxSizing: 'border-box',
  },
  clearButton: {
    padding: '10px 18px',
    backgroundColor: '#f5f5f5',
    color: '#666',
    border: '1px solid #ddd',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '0.85rem',
    fontWeight: '500',
    whiteSpace: 'nowrap',
  },
  tableCard: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    overflow: 'hidden',
  },
  tableResponsive: {
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '0.9rem',
  },
  th: {
    padding: '12px 16px',
    textAlign: 'left',
    fontWeight: '600',
    color: '#666',
    backgroundColor: '#fafafa',
    borderBottom: '2px solid #eee',
    fontSize: '0.8rem',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    whiteSpace: 'nowrap',
    userSelect: 'none',
  },
  thSortable: {
    cursor: 'pointer',
  },
  td: {
    padding: '12px 16px',
    color: '#333',
    borderBottom: '1px solid #f0f0f0',
    verticalAlign: 'middle',
  },
  trEven: {
    backgroundColor: '#fafafa',
  },
  badgeTipo: {
    display: 'inline-block',
    padding: '4px 10px',
    borderRadius: '12px',
    fontSize: '0.78rem',
    fontWeight: '600',
    backgroundColor: '#e3f2fd',
    color: '#1565c0',
  },
  laudoLink: {
    color: '#1976d2',
    textDecoration: 'none',
    fontWeight: '500',
    cursor: 'pointer',
  },
  emptyState: {
    textAlign: 'center',
    padding: '40px 20px',
    color: '#999',
  },
  loadingState: {
    textAlign: 'center',
    padding: '60px 20px',
    color: '#666',
    fontSize: '1rem',
  },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    padding: '20px 0',
    flexWrap: 'wrap',
  },
  paginationBtn: (active) => ({
    padding: '8px 14px',
    border: active ? 'none' : '1px solid #ddd',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '0.85rem',
    fontWeight: active ? '600' : '400',
    backgroundColor: active ? '#1976d2' : '#fff',
    color: active ? '#fff' : '#333',
  }),
  paginationInfo: {
    fontSize: '0.85rem',
    color: '#666',
    margin: '0 8px',
  },
};

function Exames() {
  const navigate = useNavigate();
  const [exames, setExames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [tipoFilter, setTipoFilter] = useState('');
  const [unidadeFilter, setUnidadeFilter] = useState('');
  const [sortBy, setSortBy] = useState('LAUDO');
  const [sortOrder, setSortOrder] = useState('ASC');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 25;
  const [totalItems, setTotalItems] = useState(0);
  const [filterOptions, setFilterOptions] = useState({ tipos: [], unidades: [] });
  const [contadores, setContadores] = useState({ total: 0, tipos: 0 });
  const [hoveredRow, setHoveredRow] = useState(null);

  useEffect(() => {
    fetchExames();
  }, [search, tipoFilter, unidadeFilter, sortBy, sortOrder, currentPage]);

  useEffect(() => {
    setCurrentPage(1);
  }, [search, tipoFilter, unidadeFilter]);

  const fetchExames = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({ sortBy, sortOrder });
      if (search) params.append('search', search);
      if (tipoFilter) params.append('tipo', tipoFilter);
      if (unidadeFilter) params.append('unidade', unidadeFilter);

      const response = await axios.get(`${API_URL}/exames?${params.toString()}`);
      const data = response.data.data || [];
      setTotalItems(data.length);
      setFilterOptions(response.data.filters || { tipos: [], unidades: [] });

      const tipos = new Set(data.map(e => e.TIPO).filter(Boolean));
      setContadores({ total: data.length, tipos: tipos.size });

      const startIndex = (currentPage - 1) * itemsPerPage;
      setExames(data.slice(startIndex, startIndex + itemsPerPage));
    } catch (err) {
      console.error('Erro ao buscar exames:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleSort = (field) => {
    if (sortBy === field) {
      setSortOrder(sortOrder === 'ASC' ? 'DESC' : 'ASC');
    } else {
      setSortBy(field);
      setSortOrder('ASC');
    }
  };

  const getSortIcon = (field) => {
    if (sortBy !== field) return ' ↕';
    return sortOrder === 'ASC' ? ' ↑' : ' ↓';
  };

  const formatarValor = (value) => {
    if (value === null || value === undefined || value === '') return '-';
    if (value === 'T' || value === 't') return 'Sim';
    if (value === 'F' || value === 'f') return 'Nao';
    return String(value);
  };

  const totalPages = Math.ceil(totalItems / itemsPerPage);

  if (loading && exames.length === 0) {
    return <div style={styles.loadingState}>Carregando exames...</div>;
  }

  return (
    <div className="data-page" style={{ backgroundColor: '#f5f5f5', minHeight: '100vh', fontFamily: 'Inter, Roboto, "Open Sans", sans-serif' }}>
      {/* Header */}
      <div style={styles.pageHeader}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={styles.pageIcon}>🧪</span>
          <div>
            <h1 style={styles.pageTitle}>Exames</h1>
            <p style={styles.pageSubtitle}>
              Exibindo {exames.length} de {totalItems} registros
              {(search || tipoFilter || unidadeFilter) && ' (filtrado)'}
              {loading && <span style={styles.loadingIndicator}> Carregando...</span>}
            </p>
          </div>
        </div>
      </div>

      {/* Contadores */}
      <div className="responsive-grid" style={styles.countersRow}>
        <div style={styles.counterCard('#1976d2')}>
          <div style={styles.counterLabel}>Total de Exames</div>
          <div style={styles.counterValue}>{contadores.total}</div>
        </div>
        <div style={styles.counterCard('#7b1fa2')}>
          <div style={styles.counterLabel}>Tipos</div>
          <div style={{ ...styles.counterValue, color: '#7b1fa2' }}>{contadores.tipos}</div>
        </div>
      </div>

      {/* Filtros */}
      <div className="responsive-flex page-filters" style={styles.filtersCard}>
        <div style={styles.filterGroup}>
          <label style={styles.filterLabel}>Buscar</label>
          <input
            type="text"
            placeholder="Buscar por codigo, descricao, sigla ou laudo..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={styles.searchInput}
          />
        </div>
        <div style={{ ...styles.filterGroup, flex: '0 1 200px' }}>
          <label style={styles.filterLabel}>Tipo</label>
          <select
            value={tipoFilter}
            onChange={(e) => setTipoFilter(e.target.value)}
            style={styles.filterSelect}
          >
            <option value="">Todos os tipos</option>
            {filterOptions.tipos.map(tipo => (
              <option key={tipo} value={tipo}>{tipo}</option>
            ))}
          </select>
        </div>
        <div style={{ ...styles.filterGroup, flex: '0 1 200px' }}>
          <label style={styles.filterLabel}>Unidade</label>
          <select
            value={unidadeFilter}
            onChange={(e) => setUnidadeFilter(e.target.value)}
            style={styles.filterSelect}
          >
            <option value="">Todas as unidades</option>
            {filterOptions.unidades.map(unidade => (
              <option key={unidade} value={unidade}>{unidade}</option>
            ))}
          </select>
        </div>
        {(search || tipoFilter || unidadeFilter) && (
          <button
            style={styles.clearButton}
            onClick={() => { setSearch(''); setTipoFilter(''); setUnidadeFilter(''); }}
          >
            Limpar Filtros
          </button>
        )}
      </div>

      {/* Tabela */}
      <div style={styles.tableCard}>
        <div className="exames-desktop" style={styles.tableResponsive}>
          <table className="data-table" style={styles.table}>
            <thead>
              <tr>
                <th style={{ ...styles.th, ...styles.thSortable, width: '60px' }} onClick={() => handleSort('ID')}>
                  ID{getSortIcon('ID')}
                </th>
                <th style={{ ...styles.th, ...styles.thSortable, width: '100px' }} onClick={() => handleSort('LAUDO')}>
                  Codigo{getSortIcon('LAUDO')}
                </th>
                <th style={{ ...styles.th, ...styles.thSortable }} onClick={() => handleSort('LAUDO_DESCRICAO')}>
                  Laudo{getSortIcon('LAUDO_DESCRICAO')}
                </th>
                <th style={{ ...styles.th, ...styles.thSortable }} onClick={() => handleSort('DESCRICAO')}>
                  Componente{getSortIcon('DESCRICAO')}
                </th>
                <th style={{ ...styles.th, ...styles.thSortable }} onClick={() => handleSort('MATERIAL_NOME')}>
                  Material{getSortIcon('MATERIAL_NOME')}
                </th>
                <th style={{ ...styles.th, ...styles.thSortable }} onClick={() => handleSort('METODO_NOME')}>
                  Metodo{getSortIcon('METODO_NOME')}
                </th>
                <th style={{ ...styles.th, ...styles.thSortable, width: '80px' }} onClick={() => handleSort('TIPO')}>
                  Tipo{getSortIcon('TIPO')}
                </th>
                <th style={{ ...styles.th, width: '70px', textAlign: 'center' }}>Obrig.</th>
              </tr>
            </thead>
            <tbody>
              {exames.length === 0 ? (
                <tr>
                  <td colSpan="8" style={styles.emptyState}>Nenhum exame encontrado.</td>
                </tr>
              ) : (
                exames.map((exame, index) => (
                  <tr
                    key={exame.ID}
                    style={{
                      ...(index % 2 === 0 ? {} : styles.trEven),
                      ...(hoveredRow === index ? { backgroundColor: '#e3f2fd' } : {}),
                      cursor: 'pointer',
                      transition: 'background-color 0.15s',
                    }}
                    onClick={() => navigate(`/exames/${exame.ID}`)}
                    onMouseEnter={() => setHoveredRow(index)}
                    onMouseLeave={() => setHoveredRow(null)}
                  >
                    <td style={{ ...styles.td, fontSize: '0.85rem', color: '#999' }}>{exame.ID}</td>
                    <td style={{ ...styles.td, fontWeight: '600', fontFamily: 'monospace' }}>
                      {exame.LAUDO}
                    </td>
                    <td style={styles.td}>
                      {exame.LAUDO_DESCRICAO ? (
                        <span
                          style={styles.laudoLink}
                          onClick={(e) => { e.stopPropagation(); navigate(`/laudos/${exame.LAUDO}`); }}
                        >
                          {exame.LAUDO_DESCRICAO}
                        </span>
                      ) : (
                        <span style={{ color: '#ccc' }}>-</span>
                      )}
                    </td>
                    <td style={{ ...styles.td, fontSize: '0.85rem' }}>{exame.DESCRICAO || '-'}</td>
                    <td style={{ ...styles.td, fontSize: '0.85rem' }}>{exame.MATERIAL_NOME || '-'}</td>
                    <td style={{ ...styles.td, fontSize: '0.85rem', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {exame.METODO_NOME || '-'}
                    </td>
                    <td style={styles.td}>
                      {exame.TIPO ? (
                        <span style={styles.badgeTipo}>{exame.TIPO}</span>
                      ) : '-'}
                    </td>
                    <td style={{ ...styles.td, textAlign: 'center' }}>{formatarValor(exame.OBRIGATORIO)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Mobile: Cards */}
        <div className="exames-mobile">
          {exames.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px', color: '#6b7280' }}>
              Nenhum exame encontrado.
            </div>
          ) : (
            exames.map((exame) => (
              <div
                key={exame.ID}
                className="exame-card"
                onClick={() => navigate(`/exames/${exame.ID}`)}
              >
                <div className="exame-card-header">
                  <span className="exame-card-codigo">{exame.LAUDO}</span>
                  <span className="exame-card-tipo">{exame.TIPO || '-'}</span>
                </div>
                <div className="exame-card-nome">{exame.LAUDO_DESCRICAO || exame.DESCRICAO}</div>
                {exame.DESCRICAO && exame.LAUDO_DESCRICAO && (
                  <div className="exame-card-comp">{exame.DESCRICAO}</div>
                )}
                <div className="exame-card-meta">
                  {exame.MATERIAL_NOME && <span>Mat: {exame.MATERIAL_NOME}</span>}
                  {exame.METODO_NOME && <span>Met: {exame.METODO_NOME}</span>}
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      {/* Paginacao */}
      {totalPages > 1 && (
        <div style={styles.paginationContainer}>
          <button
            style={styles.paginationBtn(false)}
            onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
            disabled={currentPage === 1}
          >
            Anterior
          </button>
          {Array.from({ length: Math.min(totalPages, 7) }, (_, i) => {
            let page;
            if (totalPages <= 7) {
              page = i + 1;
            } else if (currentPage <= 4) {
              page = i + 1;
            } else if (currentPage >= totalPages - 3) {
              page = totalPages - 6 + i;
            } else {
              page = currentPage - 3 + i;
            }
            return (
              <button
                key={page}
                style={styles.paginationBtn(page === currentPage)}
                onClick={() => setCurrentPage(page)}
              >
                {page}
              </button>
            );
          })}
          <button
            style={styles.paginationBtn(false)}
            onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
            disabled={currentPage === totalPages}
          >
            Proximo
          </button>
          <span style={styles.paginationInfo}>
            {totalItems} registros
          </span>
        </div>
      )}
    </div>
  );
}

export default Exames;
